import React, { useContext } from 'react';
import { useInterpret } from '@xstate/react';
import { useTranslation } from 'react-i18next';
import { DataAccessContext } from '@chargify/data-access';
import { useToastMessages } from '@chargify/toasts';

import { GlobalStateContext } from '../contexts';
import { customerData } from '../machines/customerData/customerData';
import { customFields } from '../machines/customFields/customFields';

type Props = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
};

export const GlobalStateProvider = ({ children }: Props) => {
  const { t } = useTranslation();
  const toastsService = useToastMessages();
  const { dataAccess } = useContext(DataAccessContext);

  const customerDataService = useInterpret(customerData, {
    services: {
      getCustomerData: () => dataAccess.getCustomerDetails(),
      saveCustomerData: (_event, payload) =>
        dataAccess.updateCustomerDetails(payload.addressData),
    },
    actions: {
      onSuccessUpdate: () => {
        toastsService.show({
          level: 'success',
          message: t('changes_saved'),
        });
      },
    },
  });

  const customFieldsService = useInterpret(customFields, {
    services: {
      getCustomerCustomFields: () => {
        return dataAccess.getCustomerCustomFields();
      },
      saveCustomerCustomFields: (_event, payload) => {
        return dataAccess.updateCustomerCustomFields(payload.fields);
      },
    },
    actions: {
      onSuccessUpdate: () => {
        toastsService.show({
          level: 'success',
          message: t('changes_saved'),
        });
      },
    },
  });

  return (
    <GlobalStateContext.Provider
      value={{ customerDataService, customFieldsService }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};
